module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t3h6O3h6O3h6O3h6O3h6O3h6O3h6O14sVl4sVm31ar1+Pp4Ir04AAAAEXRSTlMAYL//ACDP72C//wAgz+//AOAD21kAAAC9SURBVHgB7djBDsIgDIBhoINBhSm8/8NqjIc5KVkn4mH9blz+CyGkVS3awIrRU4OaSNbBhrNHQnaGD7M9EHJQ4fghDVWaHTL1kGGHgDA+5APuEPxlQ70fY8KdUmyF4oK7LbERSsiQ6JBHFk+GArIEMoRMvw9dmW4ran04WSiXp/x1qLycKiShXKoyO1QIEhofGn/98tYk1PE72pKQhORfk9D466+Tt/bXCbL/cNx/XOcvEPqtNAYsWR6Orn3uE4ELRBvCv38AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f50b.png
// module id = 1086
// module chunks = 0